import React from 'react';
import PropTypes from 'prop-types';
import { HeaderWrapper, MainHeading, SubHeading } from './styled';

const Header = ({ title, subtitle }) => (
    <HeaderWrapper>
        <MainHeading>{title}</MainHeading>
        {subtitle &&
        <SubHeading>{subtitle}</SubHeading>
        }
    </HeaderWrapper>
);

Header.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

export default Header;



// WEBPACK FOOTER //
// ./app/components/header/index.js